// src/components/panoramica/ForecastPitch.js
// Campo con l'undici della prossima giornata. Ogni giocatore: stemma dentro un
// anello che si riempie con la probabilità di giocare, fantavoto atteso,
// fascia C/VC. In orizzontale su desktop/tablet, in verticale su telefono.
import React from 'react';
import TeamBadge from '../TeamBadge';
import useIsMobile from '../../hooks/useIsMobile';
import { getPurchaseName, getPurchaseTeam } from '../auction/panoramicaEngine';
import { fvTone } from './forecastEngine';

const LINE = 'rgba(255,255,255,.35)';
const LINES_H = (
  <svg className="psq-pitch__lines" viewBox="0 0 150 100" preserveAspectRatio="none" aria-hidden="true">
    <rect x="2" y="2" width="146" height="96" fill="none" stroke={LINE} strokeWidth="0.6" />
    <line x1="75" y1="2" x2="75" y2="98" stroke={LINE} strokeWidth="0.6" />
    <circle cx="75" cy="50" r="12" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="2" y="25" width="22" height="50" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="2" y="38" width="8" height="24" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="126" y="25" width="22" height="50" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="140" y="38" width="8" height="24" fill="none" stroke={LINE} strokeWidth="0.6" />
  </svg>
);
const LINES_V = (
  <svg className="psq-pitch__lines" viewBox="0 0 100 150" preserveAspectRatio="none" aria-hidden="true">
    <rect x="2" y="2" width="96" height="146" fill="none" stroke={LINE} strokeWidth="0.6" />
    <line x1="2" y1="75" x2="98" y2="75" stroke={LINE} strokeWidth="0.6" />
    <circle cx="50" cy="75" r="12" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="25" y="2" width="50" height="22" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="38" y="2" width="24" height="8" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="25" y="126" width="50" height="22" fill="none" stroke={LINE} strokeWidth="0.6" />
    <rect x="38" y="140" width="24" height="8" fill="none" stroke={LINE} strokeWidth="0.6" />
  </svg>
);

const ROW_ORDER = ['P', 'D', 'C', 'T', 'A'];

export function pitchRowsOf(lineup) {
  if (!lineup) return [];
  if (lineup.rolesMode === 'mantra' && lineup.rows) {
    return lineup.rows.filter((r) => r.players.length).map((r) => ({ key: r.key, players: r.players }));
  }
  return ROW_ORDER
    .map((k) => ({ key: k, players: lineup.starters.filter((s) => s.forecast.role === k) }))
    .filter((r) => r.players.length);
}

export default function ForecastPitch({ lineup, onSelect }) {
  const vertical = useIsMobile();
  const rows = pitchRowsOf(lineup);
  const capId = lineup?.captain?.forecast.playerId;
  const vcId = lineup?.vice?.forecast.playerId;

  return (
    <div className={`psq-pitch pz-pitch ${vertical ? 'psq-pitch--vertical' : ''}`}>
      {vertical ? LINES_V : LINES_H}
      {rows.map((row, ri) => {
        const progress = rows.length > 1 ? ri / (rows.length - 1) : 0;
        return row.players.map((s, i) => {
          const along = 9 + progress * 82;
          const across = ((i + 1) / (row.players.length + 1)) * 100;
          const x = vertical ? across : along;
          const y = vertical ? 100 - along : across;
          const f = s.forecast;
          const armband = f.playerId === capId ? 'C' : f.playerId === vcId ? 'VC' : null;
          const risk = f.pPlay < 0.6 ? 'is-risk' : f.pPlay < 0.8 ? 'is-doubt' : '';
          return (
            <button
              key={f.playerId}
              type="button"
              className="psq-pitch__player pz-pitch__player"
              style={{ left: `${x}%`, top: `${y}%` }}
              onClick={() => onSelect?.(s)}
              aria-label={`${getPurchaseName(s.purchase)}: fantavoto atteso ${f.expFV.toFixed(1)}, gioca al ${Math.round(f.pPlay * 100)}%. Apri il dettaglio`}
            >
              <span className={`pz-ring ${risk}`} style={{ '--p': `${Math.round(f.pPlay * 100)}%` }}>
                <span className="pz-ring__inner">
                  <TeamBadge team={getPurchaseTeam(s.purchase)} size={28} showTooltip={false} />
                </span>
                {armband && <span className={`psq-pitch__armband ${armband === 'VC' ? 'psq-pitch__armband--vice' : ''}`}>{armband}</span>}
                <span className={`pz-fv ${fvTone(f)}`}>{f.expFV.toFixed(1)}</span>
              </span>
              <span className="psq-pitch__name">{getPurchaseName(s.purchase)}</span>
            </button>
          );
        });
      })}
      {!lineup?.complete && <div className="pz-pitch__warn">Rosa incompleta per questo modulo</div>}
    </div>
  );
}
